import React from "react";
import ContactSection from "@/components/sections/ContactSection";

const Footer: React.FC = () => {
  return <ContactSection />;
};

export default Footer;
